/// <reference lib="dom" />
// This file defines exports from the builtin `URL` constructor for internal
// use only.
/**
 * @internal
 */
const Builtin = URL;
export { Builtin as URL };
//# sourceMappingURL=builtin.js.map